import React from 'react';
import { Badge } from '../ui/Badge';
import { cn } from '../../utils/cn';
import type { GateItemStatus, RecordStatus, Track } from '../../types/domain';
import { trackLabel } from '../../utils/stages';
const recordStatusMap: Record<RecordStatus, {
  label: string;
  className: string;
}> = {
  'in-review': {
    label: 'In review',
    className: 'bg-muted text-foreground border-border'
  },
  'info-requested': {
    label: 'Info requested',
    className: 'bg-uae-gold/10 text-[#8a6f11] border-uae-gold/40'
  },
  active: {
    label: 'Active',
    className: 'bg-uae-leaf/10 text-uae-leaf border-uae-leaf/30'
  },
  rejected: {
    label: 'Declined',
    className: 'bg-uae-red/10 text-uae-red border-uae-red/30'
  },
  closed: {
    label: 'Closed',
    className: 'bg-muted text-muted-foreground border-border'
  }
};
export function RecordStatusPill({
  status
}: {
  status: RecordStatus;
}) {
  const config = recordStatusMap[status];
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', config.className)} data-id="element-415" data-mp="2r2hv5zpusay0">
      {config.label}
    </span>;
}
const trackClasses: Record<Track, string> = {
  mega: 'bg-uae-green text-white border-uae-green',
  major: 'bg-uae-leaf/12 text-uae-leaf border-uae-leaf/30',
  international: 'bg-[#eef2f6] text-[#3f5666] border-[#cfd9e1]'
};
export function TrackPill({
  track
}: {
  track: Track;
}) {
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', trackClasses[track])} data-id="element-416" data-mp="21rjj2i3nzz2y">
      {trackLabel(track).replace(' Event', '')}
    </span>;
}
const gateStatusMap: Record<GateItemStatus, {
  label: string;
  className: string;
}> = {
  met: {
    label: 'Met',
    className: 'bg-uae-leaf/10 text-uae-leaf border-uae-leaf/30'
  },
  partial: {
    label: 'Partial',
    className: 'bg-uae-gold/10 text-[#8a6f11] border-uae-gold/40'
  },
  outstanding: {
    label: 'Outstanding',
    className: 'bg-uae-red/10 text-uae-red border-uae-red/30'
  }
};
export function GateStatusPill({
  status
}: {
  status: GateItemStatus;
}) {
  const config = gateStatusMap[status];
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', config.className)} data-id="element-417" data-mp="2uesxh50pnnxk">
      {config.label}
    </span>;
}
export function SeverityPill({
  severity
}: {
  severity: 'critical' | 'high' | 'medium';
}) {
  const className = severity === 'critical' ? 'bg-uae-red text-white border-uae-red' : severity === 'high' ? 'bg-uae-red/10 text-uae-red border-uae-red/30' : 'bg-uae-gold/10 text-[#8a6f11] border-uae-gold/40';
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[10px] uppercase tracking-wide', className)} data-id="element-418" data-mp="26of2p6qqraza">
      {severity}
    </span>;
}
export function DocumentStatusBadge({
  status
}: {
  status: 'missing' | 'uploaded' | 'verified' | 'rejected';
}) {
  if (status === 'verified') return <Badge variant="outline" className="border-uae-leaf/30 bg-uae-leaf/10 text-uae-leaf" data-id="element-419" data-mp="874vo8pk5a2h">
        Verified
      </Badge>;
  if (status === 'uploaded') return <Badge variant="outline" className="border-border bg-muted text-foreground" data-id="element-420" data-mp="i4j9s1o0dmrm">
        Uploaded
      </Badge>;
  if (status === 'rejected') return <Badge variant="outline" className="border-uae-red/30 bg-uae-red/10 text-uae-red" data-id="element-421" data-mp="m5bnb73wydtp">
        Rejected
      </Badge>;
  return <Badge variant="outline" className="border-uae-gold/40 bg-uae-gold/10 text-[#8a6f11]" data-id="element-422" data-mp="3qkcj9wjx9xz6">
      Missing
    </Badge>;
}